import moment from 'moment';

export const getSessionAttendance = session => {
    // Linked task clock records take precedence over scheduled/manual attendance.
    // The API leaves task_check_out_time empty while the task is clocked in,
    // including when the timekeeping row initially has equal in/out timestamps.
    if (session.task_check_in_time != null) {
        return { checkedIn: true, checkedOut: session.task_check_out_time != null };
    }
    return { checkedIn: session.check_in_time != null, checkedOut: session.check_out_time != null };
};

export const getShiftStatus = (schedule, sessions, now) => {
    const start = moment(schedule.start_time);
    const end = moment(schedule.end_time);
    const scheduleSessions = sessions.filter(session => String(session.schedule_id) === String(schedule.schedule_id));
    const attendance = scheduleSessions.map(getSessionAttendance);
    const anyActive = attendance.some(item => item.checkedIn && !item.checkedOut);
    const anyCheckedIn = attendance.some(item => item.checkedIn);
    const allCheckedOut = attendance.length > 0 && attendance.every(item => item.checkedIn && item.checkedOut);

    if (anyActive) return 'inProgress';
    if (!schedule.employee_ids?.length) return 'unassigned';
    if (allCheckedOut && end.isSameOrBefore(now)) return 'completed';
    if (end.isSameOrBefore(now)) return 'missed';
    // Started but no one has clocked in yet. Not 'missed', since the caregiver can still clock in late.
    if (!anyCheckedIn && start.isSameOrBefore(now)) return 'missingCheckIn';
    return 'upcoming';
};
